import React from 'react';
import CardItem from '../CardItem';
import Footer from '../Footer';

import '../../App.css';
import '../Cards.css';
import './Services.css';
import img1 from "../pages/Image/IMG-20240618-WA0009.jpg"
import img2 from "../pages/Image/IMG-20240618-WA0010.jpg"
import img3 from "../pages/Image/IMG-20240618-WA0011.jpg"
import img4 from "../pages/Image/IMG-20240618-WA0012.jpg"
import img5 from "../pages/Image/IMG-20240618-WA0013.jpg"
import img6 from "../pages/Image/IMG-20240618-WA0014.jpg"
import img7 from "../pages/Image/IMG-20240618-WA0015.jpg"
// import img8 from "../components/pages/Image/IMG-20240618-WA0016.jpg"

import img9 from "../pages/Image/IMG-20240618-WA0027.jpg"
import img10 from "../pages/Image/IMG-20240618-WA0031.jpg"
import img11 from "../pages/Image/IMG-20240618-WA0034.jpg"

export default function Services() {
  return (
    <>
      <h1 className='services'>Explore Package</h1>
      <section className='heading'>
        <h2>Activities we think you would enjoy</h2>
        <div className='services-container'>
          <div className='services-wrapper'> 
          <ul className='services-items'>
            <CardItem 
              src={img1}
              text="Uganda is home to the Southern White Rhinos specifically found in Ziwa Rhino Sanctuary near Murchison Falls National Park where they live wildly. A small number of them can also be found in the zoo setting at the Uganda Wildlife Education Centre Entebbe."
              label="Adventure"
              path="/services/activity"
            ></CardItem>
            <CardItem 
              src={img2}
              text="Elephants in Uganda are primarily found in national parks and wildlife reserves such as queen Elizabeth National Park, Murchison Falls National Park, Kidepo Valley National Park and many others. The parks provide protected habitats where elephants can roam freely."
              label="Luxury"
              path="/services/activity"
            ></CardItem>
            <CardItem 
              src={img3}
              text="Experience Football on Top of the Himalayan Mountains"
              label="Adventure"
              path="/services/activity"
            ></CardItem>
            <CardItem 
              src={img4}
              text="Set a Sail in the Atlantic ocean visiting Uncharted Waters"
              label="Mystery"
              path="/services/activity"
            ></CardItem>
            <CardItem 
              src={img5}
              text="Ride through the Sahara Desert on a guided camel tour"
              label="Adrenaline"
              path="/services/activity"
            ></CardItem>
          </ul>
          </div>
        </div>
      </section>

      <section className='heading'>
        <h2>Explore these destinations</h2>
        <div className='services-container'>
          <div className='services-wrapper'> 
          <ul className='services-items'>
            <CardItem 
              src={img6}
              text="Budapest, Hungary"
              label="Europe"
              path="/services/activity"
            ></CardItem>
            <CardItem 
              src={img7}
              text="Lisbon, Portugal"
              label="Europe"
              path="/services/activity"
            ></CardItem>
            <CardItem 
              src={img9}
              text="Berlin, Germany"
              label="Europe"
              path="/services/activity"
            ></CardItem>
            <CardItem 
              src={img10}
              text="London, England"
              label="Europe"
              path="/services/activity"
            ></CardItem>
            <CardItem 
              src={img11}
              text="Delft, Holland"
              label="Europe"
              path="/services/activity"
            ></CardItem>
          </ul>
          </div>
        </div>
      </section>
     
    </>
  
  
  );
}